import { Container } from 'routes/components/Layout'
import { IntegrationPageHeader } from './IntegrationPageHeader'
import { IntegrationPageNavigation } from './IntegrationPageNavigation'
import classes from './IntegrationPageCommonWrapper.module.scss'

export function IntegrationPageCommonWrapper({ integration, children }) {
  return (
    <Container className={classes.wrapper}>
      <IntegrationPageHeader integration={integration} />
      <IntegrationPageNavigation integration={integration} />
      {children}
    </Container>
  )
}
